module.exports = __webpack_public_path__ + "static/img/5.5791508.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/5.png
// module id = 1EFH
// module chunks = 0